<!--  -->
<template>
  <div class="container">
    分享到: 
    <div class="bdsharebuttonbox" data-tag="share_0">
        <a  class="bds_weixin"  data-cmd="weixin" title="分享到微信"></a>
        <a  class="bds_tsina" data-cmd="tsina" title="分享到新浪微博"></a>
        <a  class="bds_sqq" data-cmd="sqq" title="分享到QQ好友"></a>
    </div>
  </div>

</template>

<script>
export default {
  name: '',
  data () {
    return {
    }
  },

  props: ['bdText', 'bdDesc', 'bdUrl', 'bdPic'],

  watch: {},

  mounted() {
    const that = this;
    this.$nextTick(function () {
      window._bd_share_config = {
        common: {
                bdText: that.bdText,
                bdDesc: that.bdDesc,
                bdUrl: that.bdUrl,
                bdPic: that.bdPic
            },
            share : [{
                tag:"share_0",
                bdSize : 32
            }],
        };
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.src = 'http://bdimg.share.baidu.com/static/api/js/share.js?v=89860593.js?cdnversion=' + ~(-new Date() / 36e5);
        document.body.appendChild(s);
    })
  },

  components: {},

  computed: {},
  
  beforeCreate () {
    window._bd_share_main = "";  
  },

  created () {
  },

  methods: {
  }
}

</script>
<style lang='scss' scoped>
.container {
  display: flex;
  align-items: center;
  display: inline-block\0;
  vertical-align: middle;
  div { margin-left: 20px; }
  .bdsharebuttonbox {
    display: inline-block\0;
    vertical-align: middle;
     a {margin-right: 15px;}
    .bds_weixin {
      width: 40px;
      height: 40px;
      background:url("../../assets/images/btn_wechat.png"); 
      background-size: 100% 100%;
    }
    .bds_tsina {
      width: 40px;
      height: 40px;
      background:url("../../assets/images/btn_sina.png"); 
      background-size: 100% 100%;
    }
    .bds_sqq {
      width: 40px;
      height: 40px;
      background:url("../../assets/images/btn_qq.png"); 
      background-size: 100% 100%; 
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/share/share.vue